import * as types from "./actionTypes";

export const ivrLoadSuccess = (response) => {
  return { type: types.LOAD_IVRS_SUCCESS, data: response };
};

export const ivrLoadError = ({ error }) => {
  return {
    type: types.LOAD_IVRS_ERROR,
    error: error,
  };
};

export const ivrListRequest = (payload) => {
  return {
    type: types.LOAD_IVRS_REQUEST,
    meta: payload,
  };
};
